import { ClientSideDelivery, LatestClientSideDelivery } from '@pubstack/common/src/clientSideDelivery'
import { MutationToasts, useMutation, useQuery } from '~/api/api-client'

export const CLIENT_SIDE_DELIVERY_QUERY_KEYS = ['client-side-delivery']
const url = '/admin/delivery'
//-------------------------------------------------------------------------
// Queries
//-------------------------------------------------------------------------
export const useClientSideDelivery = (id?: string) => {
  return useQuery<LatestClientSideDelivery>({
    url: `${url}/${id}`,
    keys: [...CLIENT_SIDE_DELIVERY_QUERY_KEYS, id ?? ''],
    enabled: !!id,
  })
}

export const useGetDeployedFiles = (component?: string) => {
  const queryResult = useQuery<string[]>({
    url: `/admin/delivery/tag-files/${component ?? ''}`,
    keys: [...CLIENT_SIDE_DELIVERY_QUERY_KEYS, 'deployed-files', component ?? ''],
    enabled: !!component,
  })
  return { ...queryResult, data: queryResult.data || [] }
}

export const useCreateClientSideDelivery = (toasts: MutationToasts = {}) => {
  return useMutation<Omit<ClientSideDelivery, 'timestamp'>>({
    method: 'post',
    url: url,
    collectionKeys: CLIENT_SIDE_DELIVERY_QUERY_KEYS,
    ...toasts,
  })
}
